import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from 'components/layout/Page';
import Faqs from 'components/marketingSite/shared/Faqs';
import Feature from 'components/marketingSite/shared/Feature';
import ButtonLink from 'components/shared/ButtonLink.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { LinkText } from 'components/shared/LinkText';
import { useI18n } from 'hooks/useI18n';
import { Faq } from 'interfaces/offer.interface';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { Heading1 } from '../../shared/Typography';
import { StyledDaily, StyledDailyHero } from './DailyComponent.styled';

export type DailyComponentProps = {
  faqs: Faq[];
};

const DailyComponent: React.FC = () => {
  const { t } = useI18n('web');
  const { locale } = useRouter();

  const faqs = [
    {
      question: t('manfred-daily.faqs.faqsList.faq1.question'),
      answer: (
        <HtmlTrans
          ns={'web'}
          i18nKey={'manfred-daily.faqs.faqsList.faq1.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('manfred-daily.faqs.faqsList.faq2.question'),
      answer: (
        <HtmlTrans
          ns={'web'}
          i18nKey={'manfred-daily.faqs.faqsList.faq2.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('manfred-daily.faqs.faqsList.faq3.question'),
      answer: (
        <HtmlTrans
          ns={'web'}
          i18nKey={'manfred-daily.faqs.faqsList.faq3.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('manfred-daily.faqs.faqsList.faq4.question'),
      answer: (
        <HtmlTrans
          ns={'web'}
          i18nKey={'manfred-daily.faqs.faqsList.faq4.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('manfred-daily.faqs.faqsList.faq5.question'),
      answer: (
        <HtmlTrans
          ns={'web'}
          i18nKey={'manfred-daily.faqs.faqsList.faq5.answer'}
          components={{
            dailyCompanies: (
              <LinkText
                href={getAppUrl(APP_URLS.manfredDailyCompanies, locale)}
              />
            )
          }}
        />
      ),
      renderComponent: true
    },
    {
      question: t('manfred-daily.faqs.faqsList.faq6.question'),
      answer: (
        <HtmlTrans
          ns={'web'}
          i18nKey={'manfred-daily.faqs.faqsList.faq6.answer'}
        />
      ),
      renderComponent: true
    }
  ];

  return (
    <Page hasScrollTop>
      <StyledDaily>
        <StyledDailyHero>
          <Heading1 editorial>{t('manfred-daily.title')}</Heading1>
          <Trans
            ns={'web'}
            i18nKey={'manfred-daily.description'}
            components={{
              p: <p />,
              strong: <strong />
            }}
          ></Trans>

          <ButtonLink
            href="https://t.me/getmanfred"
            variant="brandTalent"
            sizes="md"
          >
            <FontAwesomeIcon icon={faTelegramPlane} />
            <span>{t('talent.features.telegram.action')}</span>
          </ButtonLink>
        </StyledDailyHero>

        <Feature
          title={t('talent.features.telegram.title')}
          text={t('talent.features.telegram.desc')}
          action={t('manfred-daily.hero')}
          actionHref={getAppUrl(APP_URLS.manfredDailyCompanies, locale)}
          innerLink
          telegram={t('talent.features.telegram.telegram')}
          image="telegram.png"
          btnVariant="brandTalent"
          actionIcon={<FontAwesomeIcon icon={faTelegramPlane} />}
        />
        <Faqs faqs={faqs} title={t('manfred-daily.faqs.title')} />
      </StyledDaily>
    </Page>
  );
};

export default DailyComponent;
